import { Box, Typography } from '@mui/material'
import { useContext, useMemo, useState } from 'react'
import AppDataWrapper from '../../../components/containers/AppDataWrapper'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import TabHeader from '../../../components/navigation/TabHeader'
import { TabHeaderType } from '../../../types'
import { DashboardContext } from '../../../context'
import ProfileNotifications from '../../../components/profile/ProfileNotifications'

const NOTIFICATIONS_TAB_ID = 0
const USER_TAB_ID = 1

export default function UserProfile() {
    const dashboardContext = useContext(DashboardContext)
    const [tabSelected, setTabSelected] = useState(NOTIFICATIONS_TAB_ID)
    const userTabs: TabHeaderType[] = useMemo(() => {
        let tabs: TabHeaderType[] = [
            {
                label: 'Notificaciones' + ((dashboardContext?.appData.notificationsUnread || 0) > 0 ? ` (${dashboardContext?.appData['notificationsUnread']})` : ''),
                icon: 'bell',
                value: NOTIFICATIONS_TAB_ID
            }
        ]
        if ((dashboardContext?.appData.userInfo?.length || 0) > 0) {
            tabs = [...tabs, { label: 'Credenciales UAT', icon: 'id-card', value: USER_TAB_ID }]
        }
        return tabs
    }, [dashboardContext?.appData])


    return (
        <AppDataWrapper
            appendToolBar={<TabHeader
                tabsItems={userTabs}
                onChange={setTabSelected} selected={tabSelected}
            />}
        >
            <Box style={{ margin: '1rem' }} >
                {tabSelected === NOTIFICATIONS_TAB_ID ? <ProfileNotifications /> : <div className="form-contain">
                    {dashboardContext?.appData.userInfo.map(item => item.value && <div className='form-contain-row' key={item.id} style={{ flexDirection: 'row' }}>
                        <Typography variant='body1' component={'div'} sx={{ textAlign: 'right' }}>
                            {item.icon && <FontAwesomeIcon icon={item.icon} className='gray' style={{ marginRight: '0.5rem' }} />} {item.label}:
                        </Typography>
                        <Typography variant='body1' component={'div'}>
                            <b>{item.value}</b>
                        </Typography>
                    </div>)}
                    {dashboardContext?.appData['afore'] !== '*' && <Typography sx={{ padding: '1rem 0 0 0', textAlign: 'center' }} >
                        <b className='gray'>La contraseña productiva se solicita vía Atención a Clientes (Formato 242)</b>
                    </Typography>}
                </div>}
            </Box>
        </AppDataWrapper>
    )
}